import { render, staticRenderFns } from "./ItemAbout.vue?vue&type=template&id=33648925"
import script from "./ItemAbout.vue?vue&type=script&lang=js"
export * from "./ItemAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports